var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, formTracking } = options ;
   const is_spec_home = property.search_flags && 
   property.search_flags.is_spec_home ;
   let  thank_you_lead_text =  property.property_type == 'new_plan' || is_spec_home ? "a local builder" : "local real estate professionals";

__p+='\n\n';
 if (!property.suppress_lead_form) { 
__p+='\n  <div id="qv-form" class="leadForm lead-form-primary form-sm qv-lead-form qv-share-form">\n    <div class="share-form-title-wrap"><h3 class="lead-form-title font-semibold no-margin">Thank you for your interest!</h3><p class="font-size-base margin-top">Your message was sent to '+
((__t=(thank_you_lead_text ))==null?'':__t)+
'. Check your email for details.</p></div>\n    ';
 if (property.display_save_listing && MOVE_DATA.recaptcha_config && MOVE_DATA.recaptcha_config.enabled) { 
__p+='\n      <div class="share-form-wrap">\n        <h3 class="lead-form-title font-semibold no-margin">\n          Share this home\n        </h3>\n        <form id="share_email_'+
((__t=( formTracking.id ))==null?'':__t)+
'" action="/properties/share/email" accept-charset="UTF-8" method="post" novalidate="novalidate" data-remote="true">\n\n          <input name="utf8" type="hidden" value="&#x2713;" />\n          <input type="hidden" name="authenticity_token" value="'+
((__t=( $('meta[name="csrf-token"]').attr('content') ))==null?'':__t)+
'" />\n\n          <input type="hidden" name="property_id" id="property_id" value="'+
((__t=( property.property_id ))==null?'':__t)+
'" />\n          <input type="hidden" name="listing_id" id="listing_id" value="'+
((__t=( property.listing_id ))==null?'':__t)+
'" />\n          <input type="hidden" name="listing_type" id="listing_type" value="'+
((__t=( property.status ))==null?'':__t)+
'" />\n          <input type="hidden" name="email" id="email" value="" class="email" />\n          <input type="hidden" name="name" id="name" value="" class="fullName" />\n\n          <div class="form-group">\n            <input class="form-control" placeholder="Recipient\'s Emails" type="text" name="send_to_email" />\n          </div>\n\n          <div class="form-group">\n            <textarea class="form-control message" rows="3" col="10" origin_val="Hi! Check out the property I found on realtor.com: '+
((__t=( property.full_address_display ))==null?'':__t)+
'" name="message">Hi! Check out the property I found on realtor.com: '+
((__t=( property.full_address_display ))==null?'':__t)+
'</textarea>\n          </div>\n\n          <div class="';
 if (property.display_tcpa_message) { 
__p+='padding-bottom';
 } 
__p+='">\n            <input type="submit" name="commit" value="Send" class="submit btn btn-block btn-primary lead-form-submit round-cta" id="primary_lead_submit" data-position="top" data-disable-with="Send" />\n          </div>\n        </form>\n      </div>\n    ';
 } 
__p+='\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/forms/qv-sec-share-form.jst.ejs